import { useQuery } from "@tanstack/react-query";
import { getEmployees } from "../employees";

export const employeesKeys = {
  all: ["employees"] as const,
};

export function useEmployees() {
  return useQuery({
    queryKey: employeesKeys.all,
    queryFn: getEmployees,
  });
}